export function newsTabToggle() {
  const newsTabItemList = document.querySelectorAll('.js-newsTabItem');
  const newsBoxList = document.querySelectorAll('.js-newsBox');
  const IS_ACTIVE = 'is-active';
  const IS_VIEW = 'is-view';

  newsTabItemList.forEach((target) => {
    target.addEventListener('click', () => {
      const clickedTabData = target.dataset.newstab;

      /* タブ選択ボタンのclassを全削除 */
      for (let i = 0; i < newsTabItemList.length; i++) {
        newsTabItemList[i].classList.remove(IS_ACTIVE);
      }

      /* 表示用classを全削除 */
      for (let i = 0; i < newsBoxList.length; i++) {
        newsBoxList[i].classList.remove(IS_VIEW);
      }

      for (let i = 0; i < newsBoxList.length; i++) {
        const newsBoxData = newsBoxList[i].dataset.newsbox;

        /* 選択したタブと一致するdata属性があれば表示 */
        if (clickedTabData === newsBoxData) {
          newsBoxList[i].classList.add(IS_VIEW);
          break;
        }
      }

      target.classList.add(IS_ACTIVE);
    });
  });
}
